// Error thrown by act endpoint calls. Carries the HTTP status and the API's
// `message` body so callers can distinguish conflict (409), not-found (404), and
// validation (400) responses instead of collapsing them into a generic error.
export class ActionError extends Error {
  readonly status: number

  constructor(status: number, message: string) {
    super(message)
    this.name = 'ActionError'
    this.status = status
  }
}
